module.exports = __webpack_public_path__ + "static/c3-0eefb5d8453037592162307aa3cb81e7.jpg";